import { createFileRoute } from '@tanstack/react-router';
import UserLayout from '@components/layout/UserLayout.tsx';
import ManualSupplierPage from '@features/client/custom-suppliers/ManualSupplierPage.tsx';

export const Route = createFileRoute('/c/$orgId/$portalId/custom-suppliers')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <UserLayout>
      <ManualSupplierPage />
    </UserLayout>
  );
}
